export default __webpack_public_path__ + "static/media/logo.18e3fecc.png";